import React, { useState } from 'react';
import styled from "styled-components";
import Button, { ButtonProps } from '@material-ui/core/Button';
import { Flex, DeleteIconButton } from '../styles/global';
import { Input } from '../components/Input'
import deleteIcon from "../assets/delete.svg";

interface Props {
    groups?: any,
    setValue: (value: any) => void;
}

export const Group = ({ groups, setValue }: Props) => {
    const [groupList, setGroupList] = useState(groups || []);

    return (
        <div>
            {groupList.map((group: string, index: number) => {
                return (
                    <GroupContainer key={index} alignItems="center">
                        <Input
                            setWidth={300}
                            setValue={(value: string) => {
                                const newGroupList = [...groupList];
                                newGroupList[index] = value;
                                setGroupList(newGroupList);
                                setValue(newGroupList);
                            }}
                            value={groupList[index]}
                            required
                            requiredString="Group name required"
                        />
                        <DeleteIconButton
                            style={{ marginLeft: '12px' }}
                            onClick={() => {
                                const newGroupList = [...groupList];
                                newGroupList.splice(index, 1);
                                setGroupList(newGroupList);
                                setValue(newGroupList);
                            }}
                        >
                            <img src={deleteIcon} style={{ height: 24 }} alt="delete" />
                        </DeleteIconButton>
                    </GroupContainer>
                );
            })}
            <StyledButton
                size="large"
                variant="contained"
                disableElevation
                onClick={() => {
                    const newGroupList = [...groupList];
                    newGroupList.push("");
                    setGroupList(newGroupList);
                    setValue(newGroupList);
                }}
            >
                Add Group
            </StyledButton>
        </div>

    );
}

const StyledButton = styled(Button) <ButtonProps>`
  && {
    max-width: 280px;
  }
` as typeof Button;

const GroupContainer = styled(Flex)`
  margin-top: 24px;
  margin-bottom: 12px;
`;
